(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-medias"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'hdt-product-media[variant-media-on-demand]';
    const controller = {
      apply(gallery, variantId, jumpMedia = false) {
        const selectedId = variantId ? String(variantId) : '';
        gallery.querySelectorAll('[data-variants-id]').forEach((item) => {
          const variantIds = item.dataset.variantsId.split(';');
          item.hidden = !selectedId || !variantIds.includes(selectedId);
        });

        requestAnimationFrame(() => {
          const mainSlider = gallery.sliderMain;
          const thumbSlider = gallery.sliderThumb;
          mainSlider?.reInit?.();
          thumbSlider?.reInit?.();

          if (!jumpMedia || !selectedId) return;
          const target = Array.from(gallery.querySelectorAll('.hdt-product-media__main [data-variants-id]'))
            .find((item) => !item.hidden);
          if (!target) return;
          if (mainSlider?.isActive === false) {
            target.scrollIntoView({ block: 'start', behavior: 'smooth' });
          } else {
            mainSlider?.goToTarget?.(target);
          }
        });
      },

      init(gallery) {
        if (gallery.dataset.variantMediaOnDemandReady === 'true') return;
        const form = document.getElementById(gallery.getAttribute('form'));
        if (!form) return;
        gallery.dataset.variantMediaOnDemandReady = 'true';

        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        controller.apply(gallery, urlVariantId, Boolean(urlVariantId));
        form.addEventListener('variant:change', (event) => {
          controller.apply(gallery, event.detail?.variant?.id, true);
        });
      },

      initAll(root = document) {
        root.querySelectorAll(selector).forEach((gallery) => controller.init(gallery));
      },
    };

    window.LumeGemVariantMediaOnDemand = controller;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => controller.initAll());
    } else {
      controller.initAll();
    }
    document.addEventListener('shopify:section:load', (event) => controller.initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
